import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { AppCoreService } from 'src/app/services/app-core.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { VendorRecoService } from 'src/app/services/misc/vendorreco/vendorreco.service';
import { VendorService } from 'src/app/services/vendor.service';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { EditViewDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/delete-view.component';
import { EditDeleteActionsRenderer } from '../../shared/ag-grid/cell-renderers/edit-delete.component';
import { Utilities } from 'src/app/models/utilities';
import { HttpHeaders } from '@angular/common/http';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/services/excel.service';
import { VendorrecoDetailComponent } from './details/details.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { saveAs } from 'file-saver-es';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-vendorreco',
  templateUrl: './vendorreco.component.html',
  styleUrls: ['./vendorreco.component.scss'],
})
export class VendorReconciliationComponent implements OnInit, AfterViewInit {
  vendorReconciliationForm: FormGroup;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  isFormSubmitted: boolean;
  selectedFile: File | null = null;
  formatList = ['Standard', 'DHL', 'Fedex'];
  vendorList: any[];
  showRateDetails = false;
  showDownloadBtn = false;

  public context: any;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  vendorRecoDetailInfoId: number;

  showLogoProgressBar = false;
  logoProgress: number = 0;

  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120
  };

  gridOptionsPeriod: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 5
  }
  gridOptions: GridOptions = {
    pagination: true,
    domLayout: 'autoHeight',
    paginationPageSize: 10
  }
  rowData: any[] = [];
  rowVendorDetailData = [];

  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };

  columnDefsPeriod = [
    { headerName: 'Invoice No.', field: 'invoiceno' },
    { headerName: 'Invoice Date', field: 'invoicedate' },
    { headerName: 'Vendor', field: 'vendor' },
    { headerName: 'Format', field: 'format' },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditViewDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      sortable: false,
      filter: false,
      minWidth: 100,
    },
  ];
  columnDefs = [
    { headerName: 'AWB No', field: 'awbnumber', pinned: 'left' },
    { headerName: 'Vendor', field: 'vendor', pinned: 'left' },
    { headerName: 'Vendor AWB No', field: 'vendorawbno', pinned: 'left' },
    { headerName: 'Vendor Amount', field: 'vendoramount' },
    { headerName: 'Other Amount FuelSurcharge', field: 'otheramountfuelsurcharge' },
    { headerName: 'Other Amount No FuelSurcharge', field: 'otheramountnofuelsurcharge' },
    { headerName: 'Vendor Other Total', field: 'vendorothertotal' },
    { headerName: 'Weight', field: 'weight', minWidth: 90 },
    {
      headerName: 'Actions',
      field: 'id',
      cellRenderer: EditDeleteActionsRenderer,
      cellClass: "actions-button-cell",
      cellStyle: { "overflow": 'visible' },
      colId: 'params',
      editable: false,
      filter: false,
      sortable: false,
      minWidth: 100,
      pinned: 'right'
    },
  ];
  currentDate: any;
  showProgressBar: boolean;
  useEnterKey: any;

  constructor(
    private formBuilder: FormBuilder,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private appCoreService: AppCoreService,
    private vendorService: VendorService,
    private vendorRecoService: VendorRecoService,
    private fileHandlerService: FileHandlerService,
    private excelService: ExcelService,
    public modalService: NgbModal,
    private router: Router,
    private titleService: Title
  ) {
    titleService.setTitle('Vendor Reconciliation');
    this.context = { componentParent: this, actionConfig: { edit: true } };
  }

  ngOnInit(): void {
    // set full width for this page 
    const bodyTag = document.body;
    bodyTag.classList.add('sidebar-enable')
    bodyTag.classList.add('vertical-collpsed');

    this.currentDate = this.utilities.FormatDateWithTime();
    this.vendorReconciliationForm = this.formBuilder.group({
      ddlVendor: [null, Validators.required],
      ddlFormat: [null, Validators.required],
      txtInvoiceNo: [null, Validators.required],
      txtInvoiceDate: [this.currentDate.dateString, Validators.required],
      fileControl: [null, Validators.required]
    });
    this.checkPermission();
    this.bindVendor();
    this.bindList();
    if (this.permConfig.isViewAllowed) {
    }

  };

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.vendorReconciliationForm) : null;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    this.useEnterKey = !userData.metaInfo.tabbasedtemplate;
    const permission = userData.config.filter(x => x.categoryname === 'VendorReco');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  onGridReadyPeriod(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async successDialog(msg?: any) {
    const success = await Swal.fire({
      titleText: 'Success',
      text: msg,
      icon: 'success',
      confirmButtonText: 'Ok',
    })
    if (success.isConfirmed) {
      // this.getAllRatePeriod();
      this.isFormSubmitted = false;
      this.vendorReconciliationForm.reset();
    }
  }

  onChangeFileSelect(evt) {
    try {
      if (evt) {
        this.selectedFile = evt.target.files[0];
      }
    } catch (e) {
      console.error(e);
    }
  }

  bindVendor() {
    this.vendorService.GetAll({ isactive: true }).subscribe((res) => {
      this.vendorList = res?.success ? res.data : [];
    })
  }

  addVendorReco(fileid) {
    try {
      // if (!this.permConfig.isAddAllowed) {
      //   this.warningDialog('No access to Add.');
      //   return;
      // }      
      this.isFormSubmitted = true;
      if (this.vendorReconciliationForm.valid) {
        const requestObj = {
          invoiceno: this.vendorReconciliationForm.get('txtInvoiceNo').value,
          invoicedate: this.vendorReconciliationForm.get('txtInvoiceDate').value,
          vendor: this.vendorReconciliationForm.get('ddlVendor').value,
          format: this.vendorReconciliationForm.get('ddlFormat').value,
          fileid: fileid,
          type: 'Vendor Reconciliation'
        }

        this.ngxLoaderService.start();
        this.vendorRecoService.Add(requestObj).subscribe((res) => {
          try {
            if (res && res.success) {
              this.ngxLoaderService.stop();
              this.appCoreService.showMessage('Record Merged successfully', 'Success', 'success');
              this.bindList();
              //this.router.navigate(['/invoices/vendorreco']);
            }
            if (res && !res.success) {
              this.ngxLoaderService.stop();
              this.showProgressBar = false;
              this.warningDialog(res.message, res.data);
            }
          }
          catch (err) {
            this.ngxLoaderService.stop();
            console.error(err);
          }
        });
      }

    }
    catch (err) {
      console.error(err);
    }
  }

  bindList() {
    try {
      this.ngxLoaderService.start();
      this.vendorRecoService.GetAllList().subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;

        } else {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  //to upload data to into DB
  uploadDocument() {
    this.isFormSubmitted = true;
    // if (!this.permConfig.isAddAllowed) {
    //   this.warningDialog('No Access to Add.');
    //   return;
    // }
    try {
      let interval: any;
      let timeout: any;
      if (this.vendorReconciliationForm.valid && this.permConfig.isAddAllowed) {
        // upload file to server
        // console.log(this.selectedFile);
        if (this.selectedFile) {
          this.showLogoProgressBar = true;
          this.logoProgress = 0;
          interval = setInterval(() => {
            if (this.logoProgress < 99) {
              this.logoProgress += 1;
            }
          }, 100);
          timeout = setTimeout(() => {
            if (this.logoProgress >= 99 && this.logoProgress < 100) {
              this.appCoreService.showMessage('Error in upload. Please try again later.', 'Error', 'error');
              this.showLogoProgressBar = false;
              clearInterval(interval);
            }
          }, 5000);
          this.ngxLoaderService.start();
          let requestObj = {
            name: this.selectedFile.name,
            fileType: this.selectedFile.type,
            category: 'VENDOR'
          };

          // get signed url and upload file
          this.fileHandlerService.GetSignedURLForUpload(requestObj).subscribe(res => {
            try {
              if (res && res.success) {
                const signedUrl = res.data.uploadURL;
                const fileId = res.data.fileId;
                if (signedUrl) {
                  let headers: HttpHeaders = new HttpHeaders({
                    "Content-Type": requestObj.fileType
                  });
                  this.fileHandlerService.UploadFile(signedUrl, this.selectedFile, headers).subscribe((f) => {
                    if (f === null) {
                      // console.log('F', f);
                      this.fileHandlerService.UploadComplete({ id: fileId }).subscribe((res) => {
                        if (res && res.success) {
                          // console.log(res);
                          this.addVendorReco(fileId);
                          this.logoProgress = 100;
                          clearInterval(interval);
                          clearTimeout(timeout);
                          setTimeout(() => {
                            this.showLogoProgressBar = false;
                          }, 1000);
                          this.ngxLoaderService.stop();
                        }
                      });
                    }
                  });
                }
                this.ngxLoaderService.stop();
              }
            } catch (error) {
              console.error(error);
              this.ngxLoaderService.stop();
            }
            this.ngxLoaderService.stop();
          });
        }
      }
    } catch (e) {
      console.error(e);
    }

  }

  async warningDialog(msg: any, data: any) {
    const isHtml = msg.includes('<') && msg.includes('>');
    const confirmText = isHtml ? '<i class="bx bx-download"></li> Download' : null;
    const res = await Swal.fire({
      title: 'Warning!',
      [isHtml ? 'html' : 'text']: msg,
      icon: 'warning',
      confirmButtonText: confirmText,
      showCloseButton: true,
      showConfirmButton: isHtml,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (res.isConfirmed) {
      this.excelService.exportAsExcelFile(data, "Vendor_Reconciliation_Import");
    }
  }

  async invalidPeriodDialog(msg: string) {
    const result = await Swal.fire({
      titleText: 'Error',
      html: msg,
      icon: 'error',
      // confirmButtonText: 'Yes',
      // showDenyButton: true,
      // denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });

    if (result.isConfirmed) {
      return false;
    }
  }

  async warningDialogBar(msg?: any) {
    Swal.fire({
      titleText: 'Warning',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  bindVendorRecoDetailInfo(detailid: any) {
    this.vendorRecoService.GetVendorRecoDetailListById(detailid).subscribe(res => {
      try {
        this.ngxLoaderService.start();
        if (res) {
          this.ngxLoaderService.stop();
          if (res.data.length) {
            this.rowVendorDetailData = res.data;
            this.showRateDetails = true;
          } else {
            this.showRateDetails = false;
            this.appCoreService.showMessage('No Detail information avialable', 'Opps !', 'warning');
          }
        }
      } catch (error) {
        this.ngxLoaderService.stop();
        console.error(error);
      }
    })
  }

  viewAction(cell: any) {
    // if (!this.permConfig.isViewAllowed) {
    //   this.warningDialogBar('No Access to View.');
    // }
    // else if (this.permConfig.isViewAllowed && cell) {
    this.vendorRecoDetailInfoId = cell.id;
    this.bindVendorRecoDetailInfo(this.vendorRecoDetailInfoId);
    // }
  }

  async deletePeriodAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialogBar('No Access to Delete.');
    }
    else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.vendorRecoService.DeleteVendorRecoById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.bindList();
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  async openConfirmationDialog() {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      text: "This action is irreversible. Are you sure you want to delete?",
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  async deleteAction(cell: any) {
    if (!this.permConfig.isDeleteAllowed) {
      this.warningDialogBar('No Access to Delete.');
    }
    else if (cell && cell.id && this.permConfig.isDeleteAllowed) {
      const confirmed = await this.openConfirmationDialog();
      if (confirmed)
        this.vendorRecoService.DeleteVendorDetailRecoById(cell.id).subscribe(res => {
          try {
            if (res && res.success) {
              this.appCoreService.showMessage('Record deleted sucessfully.', 'Success', 'success');
              this.bindVendorRecoDetailInfo(this.vendorRecoDetailInfoId);
            }
          } catch (error) {
            console.error(error);
          }
        });
    }
  }

  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.warningDialogBar('No Access to Edit.')
      }
      else if (this.permConfig.isEditAllowed && cell) {
        this.vendorRecoAction(cell.id);
      }
    } catch (e) {
      console.error(e);
    }
  }

  vendorRecoAction(cell: any) {
    const modalRef = this.modalService.open(VendorrecoDetailComponent, this.ngbModalOptions);
    modalRef.componentInstance.cell = cell;
    modalRef.result.then(
      (result) => {
        if (result) {
          // console.log('Closed with: result', result);
          //this.appCoreService.showMessage('Record Updated Successfully.', 'Success', 'success')
          this.bindVendorRecoDetailInfo(this.vendorRecoDetailInfoId);
        }
      },
      (reason) => {
        // console.log('Dismissed reason', reason);
        if (reason == 'Cross click') {
          // this.bindList();
        }
      }
    );
  }

  downloadFormatFile() {
    try {
      const fileDomainURL = this.utilities.getS3DownloadURL();
      let fileName = '';
      let downloadFileURL = '';
      const selectedFormatType = this.vendorReconciliationForm.get('ddlFormat').value;
      if (selectedFormatType) {
        let filePath = '';

        if (selectedFormatType == "Standard") {
          filePath = 'vendorreco/Standard.xlsx';
        }
        else
          filePath = selectedFormatType;

        if (filePath) {
          fileName = filePath.substring(filePath.lastIndexOf('/') + 1);
        }
        downloadFileURL = `${fileDomainURL}${filePath}`;
      }

      saveAs(downloadFileURL, fileName);

    } catch (e) {
      console.log(e);
    }
  }

  onChangeFormatType() {

    if (this.vendorReconciliationForm.get('ddlFormat').value) {
      this.showDownloadBtn = true;
    }
    else {
      this.showDownloadBtn = false;
    }
  }

}
